"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getValue = exports.localTheme = void 0;
var core_1 = require("@radar-ui/core");
exports.localTheme = {
    header: {
        background_color: core_1.colors.deepSeaBlue,
        border_color: core_1.colors.mercury
    }
};
function getValue(namespace, path) {
    return (0, core_1.theme)("".concat(namespace, ".").concat(path), exports.localTheme);
}
exports.getValue = getValue;
//# sourceMappingURL=theme.js.map